module.exports = __webpack_public_path__ + "static/media/1POLICY26.81f29504.jpg";